import routerOptions0 from "/app/node_modules/.pnpm/nuxt@3.17.3_@parcel+watcher@2.5.1_@types+node@22.15.18_db0@0.3.2_eslint@9.27.0_jiti@2.4_cb5d5c2af6a1239fe3ab7b3d8a03f010/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  scrollBehaviorType: "smooth",
  hashMode: false
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}